import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { useSparkStepTypes } from '../../EntityTypes/useSparkStepTypes';
import type { SingleSparkStepResponse } from 'types/SparkStep';
import { useAddSparkStepHelper } from 'stores/sparkBuilderStore';

type MutationVariables = {
  id: string;
  stepOrder: number;
  stepTypeID: string;
  memoryID?: string | null;
  pluginID?: string | null;
  sparkID: string;
};

export function useAddSparkStep() {
  const { idMap: sparkStepTypeIdMap } = useSparkStepTypes();
  const addSparkStepHelper = useAddSparkStepHelper();
  const queryClient = useQueryClient();

  const addSparkStep = async ({
    stepOrder,
    id,
    stepTypeID,
    memoryID = null,
    sparkID,
    pluginID = null,
  }: MutationVariables) => {
    const stepTypeName = sparkStepTypeIdMap?.[stepTypeID].attributes.name;

    if (!stepTypeName) {
      Promise.reject('Invalid step Name');
      return;
    }

    const body = {
      data: {
        type: 'sparkSteps',
        id,
        attributes: {
          sparkID: sparkID,
          stepOrder: stepOrder,
          sparkStepTypeID: stepTypeID,
          name: `Step ${stepOrder}`,
          description: `Step ${stepOrder} description`,
          ...(!!memoryID && { memoryID: memoryID }),
          ...(!!pluginID && { pluginID: pluginID }),
        },
      },
    };
    return fetchWrapper<SingleSparkStepResponse>({
      url: `SparkSteps`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addSparkStep', addSparkStep, {
    onMutate: (mutationVariable) => {
      addSparkStepHelper.onMutate(mutationVariable);
    },
    onSuccess: async (data) => {
      addSparkStepHelper.onSuccess(data?.data);
    },
    onError: (error) => {
      addSparkStepHelper.onError();
      if (error instanceof Error) {
        toastr.error(`failed to add spark step: ${error.message}`);
      }
    },
  });
}
